import { useContext, useLayoutEffect } from "react";
import { WizardReceipt } from "../common/wizardReceipt";
import { ModalContext } from "../../Modal/Modal";
import Button from "@/components/bricks/button/Button";
import { useNavigate } from "react-router-dom";
import { OpretKursusQuery } from "./useOpretKursusLinje";

const OpretKursusReceipt = (props: {
  opretKursusQuery: OpretKursusQuery;
  step1;
  step2;
  setStep;
}) => {
  const { opretKursusQuery, step1, step2, setStep } = props;

  if (opretKursusQuery.isPending) return <OpretKursusReceiptLoading />;
  if (opretKursusQuery.error) {
    return (
      <OpretKursusReceiptError
        opretKursusQuery={opretKursusQuery}
        setStep={setStep}
      />
    );
  }
  if (opretKursusQuery.data) {
    return (
      <OpretKursusReceiptSuccess
        opretKursusQuery={opretKursusQuery}
        setStep={setStep}
        step1={step1}
        step2={step2}
      />
    );
  }
  return <div>error</div>;
};
export default OpretKursusReceipt;

const OpretKursusReceiptLoading = () => {
  return (
    <WizardReceipt heading="Opretter kursus ..." icon="loading">
      <p className="text-muted text-center">Dette kan tage et øjeblik</p>
    </WizardReceipt>
  );
};
const OpretKursusReceiptSuccess = (props: {
  step1;
  step2;
  setStep;
  opretKursusQuery;
}) => {
  const { opretKursusQuery, setStep, step1, step2 } = props;

  const navigate = useNavigate();
  const { setModalOpen } = useContext(ModalContext);
  useLayoutEffect(() => {
    setTimeout(() => {
      setModalOpen(false);
      step1.resetForm();
      step2.resetForm();
      setStep(1);
      navigate("/kursus/" + (opretKursusQuery.data as any).id);
    }, 3000);
  }, [navigate, opretKursusQuery.data, setModalOpen, setStep, step1, step2]);
  return (
    <WizardReceipt heading="Kursus oprettet" icon="success">
      <p className="text-muted text-center">
        Henter {opretKursusQuery.data && (opretKursusQuery.data as any).navn}
      </p>
    </WizardReceipt>
  );
};
const OpretKursusReceiptError = (props: { opretKursusQuery; setStep }) => {
  const { opretKursusQuery, setStep } = props;

  const { error, reset: resetQuery } = opretKursusQuery;

  return (
    <>
      <WizardReceipt heading="Noget gik galt" icon="warning">
        <p className="text-muted text-center">
          {(error as any)?.data?.Message ?? "Luk for at afslutte"}
        </p>
      </WizardReceipt>
      <div className="flex-100 d-flex justify-content-center mt-3">
        <Button
          color="secondary"
          onClick={() => {
            setStep(1);
            resetQuery();
          }}
        >
          Tilbage
        </Button>
      </div>
    </>
  );
};
